import React from "react";

import { Outlet } from "react-router-dom";

import { DocumentsPreuvesSubNav } from "@/pages/documentsPreuves/DocumentsPreuvesSubNav.jsx";

import {

  DOCUMENTS_PREUVES_SUB_NAV,

  SHOTOKAN_DOCUMENTS_PREUVES_BASE,

} from "@/pages/documentsPreuves/documentsPreuvesNavConfig.js";



/** Documents & Preuves intégré dans Shotokan — sous-nav seulement (BT-025). */

export function DocumentsPreuvesShotokanNestedLayout() {

  return (

    <div className="documents-preuves-nested" data-testid="documents-preuves-nested-in-shotokan">

      <DocumentsPreuvesSubNav basePath={SHOTOKAN_DOCUMENTS_PREUVES_BASE} items={DOCUMENTS_PREUVES_SUB_NAV} />

      <Outlet />

    </div>

  );

}


